// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --input-element-height: 44px;
  --input-element-height-small: calc(var(--input-element-height) * 0.5);
  --input-element-height-large: calc(var(--input-element-height) * 1.5);
  --input-element-font-size: var(--font-size-l);
  --input-element-gap: 10px;
  --input-element-gap-small: 7px;
  --text-button-min-width: 150px;
  --color-input-width: 60px;
  --dialog-element-gap: 10px;
  --dialog-padding: 30px;
  --dialog-border-radius: 8px;
  --dialog-width-l: 66.67%;
  --dialog-width-m: 50%;
  --dialog-width-s: 33.33%;
  --dialog-height-s: 40%;
  --dialog-height-l: 80%;
  --overlay-panel-border-radius: 24px;
  --overlay-panel-element-gap: 20px;
  --overlay-panel-padding: 30px;
  --scrollbar-width: 14px;
  --scrollbar-padding: 2px;
  --side-panel-min-width: max(370px, 17.5%);
  --tooltip-padding: 10px;
  --tiny-border-radius: 5px;
  --small-input-height: calc(var(--input-element-height) * 0.75);
  --small-input-border-radius: calc(var(--input-element-height) * 0.75 / 4);
}

`, "",{"version":3,"sources":["webpack://./src/ui/style/variables/sizes.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,qEAAqE;EACrE,qEAAqE;EACrE,6CAA6C;EAC7C,yBAAyB;EACzB,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,mCAAmC;EACnC,iCAAiC;EACjC,6BAA6B;EAC7B,uBAAuB;EACvB,wBAAwB;EACxB,yCAAyC;EACzC,uBAAuB;EACvB,yBAAyB;EACzB,8DAA8D;EAC9D,yEAAyE;AAC3E","sourcesContent":[":root {\n  --input-element-height: 44px;\n  --input-element-height-small: calc(var(--input-element-height) * 0.5);\n  --input-element-height-large: calc(var(--input-element-height) * 1.5);\n  --input-element-font-size: var(--font-size-l);\n  --input-element-gap: 10px;\n  --input-element-gap-small: 7px;\n  --text-button-min-width: 150px;\n  --color-input-width: 60px;\n  --dialog-element-gap: 10px;\n  --dialog-padding: 30px;\n  --dialog-border-radius: 8px;\n  --dialog-width-l: 66.67%;\n  --dialog-width-m: 50%;\n  --dialog-width-s: 33.33%;\n  --dialog-height-s: 40%;\n  --dialog-height-l: 80%;\n  --overlay-panel-border-radius: 24px;\n  --overlay-panel-element-gap: 20px;\n  --overlay-panel-padding: 30px;\n  --scrollbar-width: 14px;\n  --scrollbar-padding: 2px;\n  --side-panel-min-width: max(370px, 17.5%);\n  --tooltip-padding: 10px;\n  --tiny-border-radius: 5px;\n  --small-input-height: calc(var(--input-element-height) * 0.75);\n  --small-input-border-radius: calc(var(--input-element-height) * 0.75 / 4);\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
